<template>
  <div class="container-pay-code">
    <div class="main">
      <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
        <van-nav-bar class="van-bar" :title="$t('lang.PayCode.k001')" left-arrow @click-left="closeWeb">
          <template #left>
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          </template>
        </van-nav-bar>
      </div>
      <div class="third-pay-block">
        <iframe scrolling="yes" :src="url" frameborder="0" class="object"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    const query = this.$route.query
    return {
      barHeight: 0,
      url: query.url || null,
    }
  },
}
</script>
<style lang="scss" scoped>
.container-pay-code {
  width: 100%;
  height: 100vh;
  overflow: hidden !important;
  .main {
    position: relative;
    width: 100%;
    height: 100vh;
    padding: 0 0;
    display: flex;
    flex-direction: column;
    .third-pay-block {
      flex: 1;
      .object {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .object ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
        background-color: transparent;
      }
    }
  }
}
::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'Inter-Bold', 'Inter-Regular';
  font-weight: bold;
  color: #333333;
}
</style>
